import Vue from 'vue'
import Vuex from 'vuex'

import authentication from './authentication.module'
import alert from './alert.module'
import loader from './loader.module'
import event from './event.module'
import information from './information.module'
import action from './action.module'
import nature from './nature.module'
import origin from './origin.module'
import recipient from './recipient.module'
import translation from './translation.module'
import filters from './filters.module'
import map from './map.module'
import grid from './grid.module'
import user from './user.module'
import logs from './logs.module'
import config from './config.module'
import webmap from './webmap.module'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    authentication,
    alert,
    loader,
    event,
    information,
    action,
    nature,
    origin,
    recipient,
    translation,
    filters,
    map,
    grid,
    user,
    logs,
    config,
    webmap
  }
})

export default store
